module.exports = __webpack_public_path__ + "static/media/wordpress-ai-es.cd458c3e.png";